<template>
  <div class="search-blog">
    <form>
      <input
        type="text"
        :placeholder="placeholder"
        @input="emitValue($event.target.value)"
      />
      <button type="submit" @click="emitSearch">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24.994"
          height="25"
          viewBox="0 0 24.994 25"
        >
          <path
            d="M29.2,27.684l-6.951-7.016a9.906,9.906,0,1,0-1.5,1.523l6.906,6.971a1.07,1.07,0,0,0,1.51.039A1.077,1.077,0,0,0,29.2,27.684ZM14.465,22.275A7.822,7.822,0,1,1,20,19.984,7.774,7.774,0,0,1,14.465,22.275Z"
            transform="translate(-4.5 -4.493)"
            fill="#728391"
          />
        </svg>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  props: ["value", "type", "placeholder"],
  methods: {
    emitValue(value) {
      this.$emit("input", value);
    },
    emitSearch() {
      this.$emit("search", this.value);
    }
  }
};
</script>

<style scoped>
input:focus {
  outline: none;
}
</style>
